/**
 * Email App Labels
 */
let labels = [
    {
        name: 'module.frontend',
        value: 1,
        badgeClass: 'success'
    },
    {
        name: 'module.backend',
        value: 2,
        badgeClass: 'primary'
    },
    {
        name: 'module.api',
        value: 3,
        badgeClass: 'info'
    },
    {
        name: 'module.issue',
        value: 4,
        badgeClass: 'danger'
    }
];

export default  labels;